import { supabase } from '../lib/supabase';

export const appointmentService = {
  async getAll(userId) {
    const { data, error } = await supabase?.from('appointments')?.select('*, properties(title), clients(name)')?.eq('user_id', userId)?.order('appointment_date', { ascending: true });

    if (error) throw error;

    return data?.map(row => ({
      id: row?.id,
      title: row?.title,
      description: row?.description,
      appointmentDate: row?.appointment_date,
      duration: row?.duration,
      location: row?.location,
      status: row?.status,
      reminderSent: row?.reminder_sent,
      propertyTitle: row?.properties?.title,
      clientName: row?.clients?.name,
      propertyId: row?.property_id,
      clientId: row?.client_id,
      createdAt: row?.created_at
    }));
  },

  async create(appointment, userId) {
    const { data, error } = await supabase?.from('appointments')?.insert({
        user_id: userId,
        property_id: appointment?.propertyId || null,
        client_id: appointment?.clientId || null,
        title: appointment?.title,
        description: appointment?.description,
        appointment_date: appointment?.appointmentDate,
        duration: appointment?.duration || 60,
        location: appointment?.location,
        status: appointment?.status || 'scheduled'
      })?.select()?.single();

    if (error) throw error;
    return data;
  },

  async update(appointmentId, updates, userId) {
    const updateData = {};
    if (updates?.title) updateData.title = updates?.title;
    if (updates?.description !== undefined) updateData.description = updates?.description;
    if (updates?.appointmentDate) updateData.appointment_date = updates?.appointmentDate;
    if (updates?.duration) updateData.duration = updates?.duration;
    if (updates?.location) updateData.location = updates?.location;
    if (updates?.status) updateData.status = updates?.status;
    if (updates?.reminderSent !== undefined) updateData.reminder_sent = updates?.reminderSent;

    const { data, error } = await supabase?.from('appointments')?.update(updateData)?.eq('id', appointmentId)?.eq('user_id', userId)?.select()?.single();

    if (error) throw error;
    return data;
  },

  async delete(appointmentId, userId) {
    const { error } = await supabase?.from('appointments')?.delete()?.eq('id', appointmentId)?.eq('user_id', userId);

    if (error) throw error;
  }
};